import { BreakPriceLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/BreakPriceLine';
import { SimpleBreakPriceLine } from '../../../../components/displays/newTradingInterface/tradingModule/components/chart/chartElements/tacticLines/SimpleBreakPriceLine';
import { BreakPriceTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/exits/BreakPriceTacticPanel';
import { AddBreakPriceTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/breakPrice/AddBreakPriceTacticPanel';
import { BreakPriceWrapper } from '../../../../components/displays/tradeplans/softOrderModules/exitTacticModules/BreakPriceModule/wrapper/BreakPriceWrapper';
import BreakPriceDocs from '../../../../components/forms/tradeplans/documentation/BreakPriceDocumentation';
import BreakPriceModule from '../../../../components/forms/tradeplans/tradingPlanFormComponents/FieldComponents/exitTactics/modules/BreakPriceModule';
import { BreakPriceData } from './breakPriceData';
import { validateBreakPrice } from './validateBreakPrice';


export const BreakPrice = {
  //data class
  dataStore: BreakPriceData,

  //string constants
  name: 'BREAK_PRICE',
  tacticLabel: 'Break Price',
  addTacticLabel: 'Add Break Price',
  category: 'Exit',


  // components
  tradePlanFormModule: BreakPriceModule,
  tacticPanel: BreakPriceTacticPanel,
  addTacticPanel: AddBreakPriceTacticPanel,
  wrapper: BreakPriceWrapper,
  chartSoftOrderComponent: BreakPriceLine,
  documentation: BreakPriceDocs,
  alertDetailsComponent: null,
  simpleChartComponent: SimpleBreakPriceLine,

  //functions
  setupDetailParser: null,
  validationFunction: validateBreakPrice,
};
